const headers = [
  {
    text: 'Học sinh',
    value: 'student',
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
  },
  {
    text: 'Trạng thái',
    value: 'status',
  },
  {
    text: 'Lý do',
    value: 'notes',
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'end'
  },
  {
    text: '',
    value: 'actionDetail',
    align: 'end'
  }
]
export { headers }
